import { domHelpers } from '@approvalmax/utils';
import { stringifyUrl } from 'query-string';
import { useCallback } from 'react';
import { getApiUrl } from 'shared/data';
import { budgetsApiPaths } from 'shared/data/webApp/v1';

export const useDownloadBudget = () => {
    const downloadBudget = useCallback((budgetId: string, companyId: string) => {
        const url = stringifyUrl({ url: budgetsApiPaths.downloadXeroBudgetSourceFile, query: { budgetId, companyId } });
        const apiUrl = getApiUrl();

        domHelpers.downloadUrl(`${apiUrl}/${url}`);
    }, []);

    return {
        downloadBudget,
    };
};
